import React, { FunctionComponent, useState } from 'react'
import clsx from 'clsx'

import { Icon } from '../Icon'
import { StoreLogoBackground, StoreLogoBackgrounds, StoreLogoSize, StoreLogoSizes } from './constants'

import styles from './style.module.scss'
import { useThemeClass } from '../Theme'

export interface StoreLogoProps {
  alt?: string
  background?: StoreLogoBackground
  size?: StoreLogoSize
  testNameSpace?: string
  url?: string
}

export const StoreLogo: FunctionComponent<StoreLogoProps> = ({
  alt = '',
  background = StoreLogoBackgrounds.Default,
  size = StoreLogoSizes.Medium,
  testNameSpace = '',
  url,
  ...otherProps
}) => {
  const themeClass = useThemeClass()
  const [isError, setIsError] = useState(typeof url === 'undefined')
  const hasTestId = testNameSpace.length > 0

  const componentStyle = clsx(
    styles.component,
    background === StoreLogoBackgrounds.Default && styles.defaultBackground,
    background === StoreLogoBackgrounds.Alternative && styles.alternativeBackground,
    size === StoreLogoSizes.Medium && styles.sizeMedium,
    size === StoreLogoSizes.Large && styles.sizeLarge,
    styles[themeClass]
  )

  const iconSize = size === StoreLogoSizes.Large ? 'Large' : 'Medium'

  return (
    <span className={componentStyle} {...(hasTestId && { 'data-testid': `${testNameSpace}-storeLogo` })}>
      <span className={styles.content}>
        {isError && <Icon.Merchant title={alt} size={iconSize} />}
        {!isError && (
          <img
            src={url}
            onError={() => setIsError(true)}
            alt={alt}
            className={styles.image}
            {...(hasTestId && { 'data-testid': `${testNameSpace}-storeLogo-img` })}
            {...otherProps}
          />
        )}
      </span>
    </span>
  )
}
